import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@storable/canaveral-components';
import AdminHeader from '../../../src/admin/layout/containers/AdminHeader';
import { FLIPPER_INTERNATIONALIZATION, FLIPPER_VOYAGER_HEADER_FOOTER_SETS } from '../../../constants/flippers';
import useFlipper from '../../../modules/react/hooks/useFlipper';
import PageLayoutLocalesDropdown from '../../containers/PageLayoutLocalesDropdown';
import PageLayoutTypesDropdown from '../../containers/PageLayoutTypesDropdown';
import PageLayoutHeaderControls from '../../containers/PageLayoutHeaderControls';

const propTypes = {
  localeCode: PropTypes.string.isRequired,
  typeId: PropTypes.string.isRequired,
  versionId: PropTypes.string.isRequired,
};

const defaultProps = {};

const PageLayoutAdminHeader = ({
  localeCode,
  typeId,
  versionId,
}) => {
  const i18nEnabled = useFlipper(FLIPPER_INTERNATIONALIZATION);
  const pageLayoutsEnabled = useFlipper(FLIPPER_VOYAGER_HEADER_FOOTER_SETS);

  return (
    <AdminHeader
      title="Layout Builder"
      controls={
        <PageLayoutHeaderControls localeCode={localeCode} typeId={typeId} versionId={versionId} />
      }
    >
      {i18nEnabled && (
        <Layout.Header.Group bordered>
          <PageLayoutLocalesDropdown
            localeCode={localeCode}
            typeId={typeId}
          />
        </Layout.Header.Group>
      )}
      {pageLayoutsEnabled && (
        <Layout.Header.Group bordered>
          <PageLayoutTypesDropdown
            localeCode={localeCode}
            typeId={typeId}
          />
        </Layout.Header.Group>
      )}
    </AdminHeader>
  );
};

PageLayoutAdminHeader.propTypes = propTypes;
PageLayoutAdminHeader.defaultProps = defaultProps;

export default PageLayoutAdminHeader;
